// src/components/Course/VideoPlayer.jsx
import React, { useEffect, useRef } from "react";
import VideoDescription from "./Vedio_decription";

const VideoPlayer = ({ video, onComplete }) => {
  const videoRef = useRef();

  useEffect(() => {
    if (!video) return;

    const vid = videoRef.current;

    const handleEnd = () => {
      onComplete && onComplete(video.id);
    };

    vid.addEventListener("ended", handleEnd);

    return () => {
      vid.removeEventListener("ended", handleEnd);
    };
  }, [video]);

  if (!video) {
    return <div className="text-center py-5 text-muted">Select a video to start…</div>;
  }

  return (
    <>
     {/* VIDEO HEADING + TITLE */}
<div className="mb-3">

  {/* Heading (optional) */}
  {video.heading && (
    <h3 className="fw-bold mb-1" style={{ fontSize: "22px" }}>
      {video.heading}
    </h3>
  )}

  {/* Title (optional) */}
  {video.title && (
    <h5 className="text-muted mb-0" style={{ fontSize: "16px" }}>
      {video.title}
    </h5>
  )}

</div>


      <video
        ref={videoRef}
        key={video.id}
        src={video.url}
        controls
        className="w-100 rounded shadow-sm mb-3"
      />

      {/* Duration */}
      <div className="text-muted mb-2">Duration: {video.duration}</div>

      {/* Description */}
   
   <VideoDescription description={video.description} lines={4} />    
    
    </>
  );
};

export default VideoPlayer;
